import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { CheckoutCreditCard } from "@/backend-sdk/client/types.gen";

export interface CardFormState {
  holderName: string;
  number: string;
  expiryMonth: string;
  expiryYear: string;
  ccv: string;
}

interface CreditCardFormProps {
  value: CardFormState;
  onChange: (value: CardFormState) => void;
}

export const CreditCardForm = ({ value, onChange }: CreditCardFormProps) => {
  const set = (patch: Partial<CardFormState>) =>
    onChange({ ...value, ...patch });

  return (
    <div className="space-y-3 rounded-lg border border-slate-200 p-3">
      <div>
        <Label htmlFor="card-holder">Nome no cartão</Label>
        <Input
          id="card-holder"
          value={value.holderName}
          onChange={(e) => set({ holderName: e.target.value })}
          placeholder="Como impresso no cartão"
        />
      </div>
      <div>
        <Label htmlFor="card-number">Número do cartão</Label>
        <Input
          id="card-number"
          inputMode="numeric"
          value={value.number}
          onChange={(e) => set({ number: e.target.value })}
          placeholder="0000 0000 0000 0000"
        />
      </div>
      <div className="grid grid-cols-3 gap-2">
        <div>
          <Label htmlFor="card-mm">Mês</Label>
          <Input
            id="card-mm"
            inputMode="numeric"
            maxLength={2}
            value={value.expiryMonth}
            onChange={(e) => set({ expiryMonth: e.target.value })}
            placeholder="MM"
          />
        </div>
        <div>
          <Label htmlFor="card-yy">Ano</Label>
          <Input
            id="card-yy"
            inputMode="numeric"
            maxLength={4}
            value={value.expiryYear}
            onChange={(e) => set({ expiryYear: e.target.value })}
            placeholder="AAAA"
          />
        </div>
        <div>
          <Label htmlFor="card-ccv">CVV</Label>
          <Input
            id="card-ccv"
            inputMode="numeric"
            maxLength={4}
            value={value.ccv}
            onChange={(e) => set({ ccv: e.target.value })}
            placeholder="123"
          />
        </div>
      </div>
    </div>
  );
};

export const isCardDataComplete = (card: CardFormState): boolean =>
  Boolean(
    card.holderName &&
    card.number &&
    card.expiryMonth &&
    card.expiryYear &&
    card.ccv,
  );

export const toCheckoutCreditCard = (
  card: CardFormState,
): CheckoutCreditCard => ({
  holder_name: card.holderName,
  number: card.number.replace(/\D/g, ""),
  expiry_month: card.expiryMonth,
  expiry_year: card.expiryYear,
  ccv: card.ccv,
});
